import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import '../static/style/button.css';


class Button extends Component {
    constructor(props) {
        super(props);

        this.reroute = this.reroute.bind(this);
    }

    reroute() {
    /**
     * When Button element is clicked redirect user to correct URL by using router provided in props.
     */
        if (this.props.history) {
            this.props.history.push(this.props.btnPath);
        }
    }

    render() {

        const { props } = this;

        if (props.onClick) {
            return (
                <button className={ 'btn btn-' + props.btnStyle } onClick={props.onClick}>{ props.btnText }</button>

            )
        }
        return (
            <div onClick={this.reroute} className={'btn btn-' + props.btnStyle}>{ props.btnText }</div>
        )
    }
}

/*
 Connect Router props to Button component so it is not necessary to pass along with every component
 initialization. This allows access to same Router that server side has used.
 */
export default withRouter(connect()(Button));


// WEBPACK FOOTER //
// ./src/components/Button.js